// Skill level system: 1.0 - 7.0 scale (initial selection 1.0-5.0, above 5.0 earned through matches)
// Initial values based on player's self-assessment during onboarding

export const skillLevelConfig: Record<number, { name: string; description: string; initialLevel: number }> = {
  1: { 
    name: "Iniciación", 
    description: "Aprendiendo las reglas y golpes básicos",
    initialLevel: 1.0 
  },
  2: { 
    name: "Básico", 
    description: "Peloteos lentos. Empieza a usar la pared de fondo y a subir a la red.",
    initialLevel: 2.0 
  },
  3: { 
    name: "Intermedio", 
    description: "Juego cruzado y globos. Uso de bandeja y voleas para dominar la red.",
    initialLevel: 3.0 
  },
  4: { 
    name: "Avanzado", 
    description: "Control de paredes dobles. Ritmo alto, pocos errores y remate con intención.",
    initialLevel: 4.0 
  },
  5: { 
    name: "Muy Avanzado", 
    description: "Nivel de competición muy avanzado, en categorías superiores de nivel amateur/semi profesional. Dominio de efectos, potencia y táctica profesional.",
    initialLevel: 5.0 
  },
};

// Get initial level value from onboarding selection (1-5 integer -> decimal)
export const getInitialLevel = (selection: number): number => {
  return skillLevelConfig[selection]?.initialLevel || 2.0;
};

// Format level for display (2 decimal places)
export const formatLevel = (level: number | null | undefined): string => {
  if (level === null || level === undefined) return "-";
  return level.toFixed(2);
};

// Get color class based on level
export const getLevelColor = (level: number): string => {
  if (level < 1.5) return "bg-green-500";
  if (level < 2.5) return "bg-teal-500";
  if (level < 3.5) return "bg-blue-500";
  if (level < 4.5) return "bg-violet-500";
  if (level < 5.5) return "bg-amber-500";
  if (level < 6.5) return "bg-orange-500";
  return "bg-red-500";
};

// Clamp level to valid range (1.0-7.0, but only achievable above 5.0 through matches)
export const clampLevel = (level: number): number => {
  return Math.max(1.0, Math.min(7.0, level));
};
